'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/Selectfield.css');

require('../css/ControlBase.css');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _utilsLib = require('utils-lib');

var _Vas = require('../../build/Vas');

var _Vas2 = _interopRequireDefault(_Vas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:
AppURL={Vas.ApplicationUrl} 
SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
me={this} ref={"Gender"} Id={"Gender"}  
IsRequired={true/false} 
Label={Vas.Resources.Labels["Gender"]} 
Data={ [{Key: 'Männlich', Display: Vas.Resources.Labels["Male"] },{Key: 'Weiblich', Display: Vas.Resources.Labels["Female"]}]}                                        
Selected={true/false}
Picker={true/false}

optional:
Float={'left'}
Tooltip={Vas.Resources.Tooltips["Gender"]}
OnBlur={()=>{ this.setState({ Gender: $("#Gender").val()})} }
OnChange={()=>{this.setDate(this)}}
Width={70}   
 Default={this.state.currentYear}
*/

var SelectField = function (_Component) {
    _inherits(SelectField, _Component);

    function SelectField(props) {
        _classCallCheck(this, SelectField);

        var _this = _possibleConstructorReturn(this, (SelectField.__proto__ || Object.getPrototypeOf(SelectField)).call(this, props));

        _this.state = {};
        _this.state.Data = props.Data;
        _this.state.Default = props.Default;
        _this.state.selected = props.Selected;
        _this.state.Label = props.Label;
        _this.state.isrequired = _this.props.IsRequired;
        _this.state.required = true;
        _this.state.OnChange = _this.props.OnChange;
        _this.state.ShowDouble = _this.props.ShowDouble !== null && _this.props.ShowDouble !== undefined ? _this.props.ShowDouble : true;
        _this.state.Scroll = _this.props.Scroll !== null && _this.props.Scroll !== undefined ? _this.props.Scroll : false;
        return _this;
    }

    _createClass(SelectField, [{
        key: 'componentDidMount',
        value: function componentDidMount() {

            if (this.state.Data) {
                if (!this.props.Picker) {
                    if (this.state.Default) {
                        document.getElementById(this.props.Id).selectedIndex = 0;
                        for (var i = 0; i < this.state.Data.length; i++) {
                            if (this.state.Data[i]["Display"] === this.state.Default) {
                                document.getElementById(this.props.Id).selectedIndex = i + 1;
                                break;
                            }
                        }
                    }
                } else {
                    if (this.state.Default) {
                        var cur = this.state.Default.toString();
                        if (cur.length < 4) {
                            document.getElementById(this.props.Id).selectedIndex = this.state.Default;
                        } else {
                            for (var _i = 0; _i < this.state.Data.length; _i++) {
                                if (this.state.Data[_i]["Display"] === this.state.Default) {
                                    document.getElementById(this.props.Id).selectedIndex = _i;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {

            if (this.state.Data) {
                if (!this.props.Picker) {
                    if (this.state.Default) {
                        if (document.getElementById(this.props.Id).selectedIndex <= 0) {
                            document.getElementById(this.props.Id).selectedIndex = 0;
                            for (var i = 0; i < this.state.Data.length; i++) {
                                if (this.state.Data[i]["Display"] === this.state.Default) {
                                    document.getElementById(this.props.Id).selectedIndex = i + 1;
                                    break;
                                }
                            }
                        }
                    } else {
                        if (this.state.Data.length === 1) {
                            if (document.getElementById(this.props.Id).selectedIndex !== 1) {
                                document.getElementById(this.props.Id).selectedIndex = 1;
                                if (this.state.OnChange) {
                                    this.state.OnChange();
                                }
                            }
                        }
                    }
                } else {
                    if (this.state.Default) {
                        var cur = this.state.Default.toString();
                        if (_utilsLib.CheckValues.includes(this.props.Id, "sfYeardb")[0] === true) {
                            if (cur.length < 4) {
                                document.getElementById(this.props.Id).selectedIndex = this.state.Default;
                            } else {
                                if (document.getElementById(this.props.Id).selectedIndex < 0) {
                                    document.getElementById(this.props.Id).selectedIndex = 0;
                                    for (var _i2 = 0; _i2 < this.state.Data.length; _i2++) {
                                        if (this.state.Data[_i2]["Display"] === this.state.Default) {
                                            document.getElementById(this.props.Id).selectedIndex = _i2;
                                            break;
                                        }
                                    }
                                }
                            }
                        } else if (_utilsLib.CheckValues.includes(this.props.Id, "sfMonthdb")[0] === true) {
                            if (cur.length < 1) {
                                document.getElementById(this.props.Id).selectedIndex = this.state.Default;
                            } else {
                                if (document.getElementById(this.props.Id).selectedIndex < 0) {
                                    document.getElementById(this.props.Id).selectedIndex = 0;
                                    for (var _i3 = 0; _i3 < this.state.Data.length; _i3++) {
                                        if (this.state.Data[_i3]["Display"] === this.state.Default) {
                                            document.getElementById(this.props.Id).selectedIndex = _i3;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        if (document.getElementById(this.props.Id).selectedIndex < 0) {
                            document.getElementById(this.props.Id).selectedIndex = 0;
                        }
                    }
                }
            }

            this.FontSizeClick();
        }
    }, {
        key: 'checkValue',
        value: function checkValue(me) {
            me.checkFields(me);
            var filled = true;
            if (me.state.isrequired) {
                if (me.state.Data) {
                    if (me.state.Data.length === 1) {
                        document.getElementById(me.props.Id).selectedIndex = 1;
                        filled = true;
                    } else {
                        if (document.getElementById(me.props.Id).selectedIndex > 0) {
                            filled = true;
                        } else {
                            filled = false;
                        }
                    }
                }
            }
            me.setState({ required: filled });
        }
    }, {
        key: 'tab',
        value: function tab(event, me) {
            if (event) {
                if (document.getElementById(me.props.Id)) {
                    if (document.getElementById(me.props.Id).length > 0) {
                        if (event.keyCode === 13 || event.keyCode === 9 || event.keyCode === 32 || event.keyCode === undefined) {
                            if (event.keyCode === 32) {
                                var _event = new Event("change");
                                document.getElementById(this.props.Id).dispatchEvent(_event);
                            } else {
                                this.checkValue(me);
                            }

                            var docs = document.querySelectorAll('select,input,div.extendedButton');
                            var maxId = docs.length;
                            var aktive = document.activeElement.id;
                            var i = void 0;
                            for (i = 0; i < maxId - 1; i++) {
                                if (docs[i].id === aktive) {
                                    if (event.shiftKey && event.keyCode === 9) {
                                        for (var j = i - 1; j >= 0; j--) {
                                            if (!docs[j].readOnly) {
                                                docs[j].focus();
                                                break;
                                            } else if (docs[j].className === "extendedButton") {
                                                docs[j].focus();
                                                break;
                                            }
                                        }
                                    } else {
                                        for (var _j = i + 1; _j <= maxId - 1; _j++) {
                                            if (!docs[_j].readOnly) {
                                                docs[_j].focus();
                                                break;
                                            } else if (docs[_j].className === "extendedButton") {
                                                docs[_j].focus();
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        me.checkFields(me);
                    }
                }
            }
        }
    }, {
        key: 'checkFields',
        value: function checkFields(me) {
            if (me.props.me) {
                var docs = document.querySelectorAll('select,input');
                var docRefs = me.props.me.refs;
                _utilsLib.CheckValues.checkAllFields(docs, docRefs, me.props.Id);
            }
        }
    }, {
        key: 'getValue',
        value: function getValue(me) {
            return (0, _jquery2.default)("#" + me.props.Id).val();
        }
    }, {
        key: 'FontSizeClick',
        value: function FontSizeClick() {
            var schriftgröße = localStorage.getItem('Schriftgröße');

            //Schriftgröße bei Klick in 2er Schritten erhöhen

            if (schriftgröße != null) {
                switch (schriftgröße) {
                    case "0":
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                        break;
                    case "1":
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                        break;
                    case "2":
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                        break;
                    case "3":
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                        break;
                    case "4":
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                        break;
                    case "5":
                        (0, _jquery2.default)('#TariffProducts').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                        break;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var Tooltip = "";

            if (this.props.Tooltip) {
                Tooltip = _react2.default.createElement(
                    'span',
                    { id: this.props.Id + "Tooltip" },
                    this.props.Tooltip
                );
            }

            var FieldNotFilled = "";

            if (this.props.FieldNotFilledHint && this.props.FieldNotFilledHint !== "") {
                FieldNotFilled = _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "FieldNotFilled", className: "fieldNotFilled" },
                    this.props.FieldNotFilledHint
                );
            }

            var Style = null;
            var StyleSelect = null;
            if (this.props.Width || this.props.Float) {
                if (this.state.Scroll === true) {
                    Style = { width: this.props.Width, float: this.props.Float, overflowX: "scroll" };
                    StyleSelect = { float: this.props.Float, width: "auto" };
                } else {
                    Style = { width: this.props.Width, float: this.props.Float };
                    StyleSelect = { width: this.props.Width, float: this.props.Float };
                }
            } else {
                if (this.state.Scroll === true) {
                    Style = { width: "170px", float: "left", overflowX: "scroll" };
                    StyleSelect = { float: "left", width: "auto" };
                }
            }

            var StyleLabel = { width: this.props.Width, float: this.props.Float };;
            if (this.props.LabelHeight) {
                StyleLabel = { width: this.props.Width, float: this.props.Float, height: this.props.LabelHeight };
            }
            var options = [];

            //VAS-29863: Geschlecht für Erzeihungsberechtigten wurde in Oberfläche nicht angezeigt
            //Ursache: irgendetwas mit props.ref -> geht bei ref = gender; geht auch bei ref = genderAccountOwner; geht nicht bei ref = genderLegalGuardien
            //Warum: Antwort auf die Frage ist offen; this.props.Data ist gefüllt; this.state.Data ist nicht gefüllt, trotz Zuweisung im Konstruktor
            //Workaround hier: this.state.Data erneut this.props.Data zuweisen, wenn undefined
            //Ergebnis: Geschlecht für Erzeihungsberechtigten wird angezeigt
            if (this.state.Data == undefined && this.props.Data != undefined) {
                this.state.Data = this.props.Data;
            }

            if (this.state.Data) {
                if (!this.props.Picker) {
                    var arr = [];
                    if (this.props.SelectFieldChooseText == "HiddenPleaseChoose") {
                        options.push(_react2.default.createElement(
                            'option',
                            {
                                key: "Wählen",
                                value: "Wählen",
                                hidden: "true" },
                            ' ',
                            this.props.SelectFieldChooseText ? this.props.SelectFieldChooseText : _Vas2.default.getText('Labels', 'PleaseChoose')
                        ));
                    } else {
                        options.push(_react2.default.createElement(
                            'option',
                            {
                                key: "Wählen",
                                value: "Wählen" },
                            ' ',
                            this.props.SelectFieldChooseText ? this.props.SelectFieldChooseText : _Vas2.default.getText('Labels', 'PleaseChoose')
                        ));
                    }

                    if (this.state.ShowDouble === true) {
                        for (var i = 0; i < this.state.Data.length; i++) {
                            //if (arr.indexOf(this.state.Data[i]["Display"]) === -1){
                            options.push(_react2.default.createElement(
                                'option',
                                {
                                    key: this.state.Data[i]["Display"],
                                    value: this.state.Data[i]["Key"] },
                                ' ',
                                this.state.Data[i]["Display"]
                            ));
                            arr.push(this.state.Data[i]["Display"]);
                            //}
                        }
                    } else {
                        for (var _i4 = 0; _i4 < this.state.Data.length; _i4++) {
                            var included = false;
                            for (var j = 0; j < options.length; j++) {
                                if (this.state.Data[_i4]["Display"] === options[j].key) {
                                    included = true;
                                    break;
                                }
                            }
                            if (included === false) {
                                options.push(_react2.default.createElement(
                                    'option',
                                    {
                                        key: this.state.Data[_i4]["Display"],
                                        value: this.state.Data[_i4]["Key"] },
                                    ' ',
                                    this.state.Data[_i4]["Display"]
                                ));
                                arr.push(this.state.Data[_i4]["Display"]);
                            } else {
                                options.push(_react2.default.createElement(
                                    'option',
                                    { disabled: true, style: { display: "none" },
                                        key: this.state.Data[_i4]["Display"],
                                        value: this.state.Data[_i4]["Key"] },
                                    ' ',
                                    this.state.Data[_i4]["Display"]
                                ));
                                arr.push(this.state.Data[_i4]["Display"]);
                            }
                        }
                    }
                } else {
                    for (var _i5 = 0; _i5 < this.state.Data.length; _i5++) {
                        if (this.state.Default) {
                            if (this.state.Data[_i5]["Key"] === this.state.Default) {
                                options.push(_react2.default.createElement(
                                    'option',
                                    {
                                        key: this.state.Data[_i5]["Display"],
                                        value: this.state.Data[_i5]["Key"] },
                                    ' ',
                                    this.state.Data[_i5]["Display"]
                                ));
                            } else {
                                options.push(_react2.default.createElement(
                                    'option',
                                    {
                                        key: this.state.Data[_i5]["Display"],
                                        value: this.state.Data[_i5]["Key"] },
                                    ' ',
                                    this.state.Data[_i5]["Display"]
                                ));
                            }
                        } else {
                            options.push(_react2.default.createElement(
                                'option',
                                {
                                    key: this.state.Data[_i5]["Display"],
                                    value: this.state.Data[_i5]["Key"] },
                                ' ',
                                this.state.Data[_i5]["Display"]
                            ));
                        }
                    }
                }
            } else {
                options.push(_react2.default.createElement('option', null));
            }

            var controlClassName = '';
            var isTextFieldFilled = true;
            if (this.state.isrequired) {
                if (this.state.required) {
                    controlClassName = "selectField";
                } else {
                    controlClassName = "selectFieldNotFilled";
                    isTextFieldFilled = false;
                }
            } else {
                controlClassName = "selectField";
            }

            var icon = '';
            if (this.state.Icon) {
                var len = document.getElementById(this.props.Id).offsetWidth;
                icon = _react2.default.createElement(
                    'label',
                    {
                        className: 'iconClass',
                        htmlFor: this.props.Id },
                    _react2.default.createElement(_Icon2.default, {
                        Name: this.state.Icon,
                        AppURL: this.props.AppURL,
                        Size: 18,
                        Color: "black",
                        Align: "left",
                        PaddingLeft: "" + (len - 38) + "px" })
                );
            }
            var loading = '';
            if (this.state.Loading) {
                if (this.state.Loading === false) {
                    loading = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'label',
                            {
                                htmlFor: this.props.Id },
                            _react2.default.createElement('div', {
                                id: this.props.Id + "Loading",
                                className: 'hide',
                                float: 'right' })
                        )
                    );
                } else {
                    loading = _react2.default.createElement(
                        'div',
                        { style: { float: "right", lineHeight: "30px", paddingRight: "20px" } },
                        _react2.default.createElement(
                            'label',
                            {
                                htmlFor: this.props.Id,
                                style: { float: "right", lineHeight: "30px", bottom: "20px", position: 'absolute' } },
                            _react2.default.createElement('div', {
                                id: this.props.Id + "Loading",
                                className: 'loaderComponent',
                                float: 'right' })
                        )
                    );
                }
            }

            var isTextFieldFilledStyle = { visibility: 'hidden' };

            if (!isTextFieldFilled) {
                isTextFieldFilledStyle = { visibility: 'visible' };
            }

            return _react2.default.createElement(
                'div',
                { className: "sf" },
                _react2.default.createElement(
                    'div',
                    {
                        className: 'selectFieldLabel',
                        style: StyleLabel,
                        id: this.props.Id + "Label" },
                    this.state.Label,
                    '  ',
                    Tooltip
                ),
                _react2.default.createElement(
                    'div',
                    {
                        className: 'selectField',
                        style: Style },
                    _react2.default.createElement(
                        'select',
                        {
                            onFocus: function onFocus() {

                                //document.getElementById(this.props.Id).size = this.state.Data.length + 1 ; 
                            },
                            id: this.props.Id,
                            style: StyleSelect,
                            className: controlClassName,
                            onBlur: function onBlur(e) {
                                if (_this2.props.OnBlur) {
                                    _this2.props.OnBlur();
                                }_this2.checkValue(_this2);
                            },
                            onKeyDown: function onKeyDown(e) {
                                if (e.keyCode === 9) {
                                    e.preventDefault();
                                }
                                _this2.tab(e, _this2);
                            },
                            onChange: function onChange(e) {
                                //document.getElementById(this.props.Id).size=1; 
                                if (_this2.state.OnChange) {
                                    _this2.state.OnChange();
                                }
                                _this2.checkValue(_this2);
                                //document.getElementById(this.props.Id).blur();
                            }
                        },
                        options
                    ),
                    loading,
                    icon
                ),
                _react2.default.createElement(
                    'div',
                    { id: this.props.Id + "FieldNotFilled", style: isTextFieldFilledStyle },
                    FieldNotFilled
                )
            );
        }
    }]);

    return SelectField;
}(_react.Component);

exports.default = SelectField;